/* eslint-disable react/require-default-props */
import { Tooltip } from '@mui/material';
import { useMemo } from 'react';

import { cleanValue } from '../../helpers';
import { StyledButton } from './styles';

interface MapSearchButtonLabels {
  searchMap: string;
  mapUpdated: string;
  fieldsIncomplete: string;
}

interface MapSearchButtonProps {
  cep: string;
  address: string;
  addressNumber: string;
  district: string;
  city: string;
  uf: string | number;
  isWithoutNumber?: boolean;
  hasSearched: boolean;
  isAddressEdited: boolean;
  disabled?: boolean;
  labels: MapSearchButtonLabels;
  onClick: () => void;
}

const CEP_LENGTH = 8;

export default function MapSearchButton({
  cep,
  address,
  addressNumber,
  district,
  city,
  uf,
  isWithoutNumber,
  hasSearched,
  isAddressEdited,
  disabled,
  labels,
  onClick,
}: MapSearchButtonProps): JSX.Element {
  const { isButtonDisabled, tooltipTitle, buttonText } = useMemo(() => {
    const fieldsComplete =
      cleanValue(cep).length === CEP_LENGTH &&
      !!address &&
      (!!addressNumber || !!isWithoutNumber) &&
      !!district &&
      !!city &&
      !!uf;
    const alreadySearched = hasSearched && !isAddressEdited;
    return {
      isButtonDisabled: !!disabled || !fieldsComplete || alreadySearched,
      tooltipTitle: !disabled && !fieldsComplete ? labels.fieldsIncomplete : '',
      buttonText: alreadySearched ? labels.mapUpdated : labels.searchMap,
    };
  }, [
    cep,
    address,
    addressNumber,
    district,
    city,
    uf,
    isWithoutNumber,
    hasSearched,
    isAddressEdited,
    disabled,
    labels.searchMap,
    labels.mapUpdated,
    labels.fieldsIncomplete,
  ]);

  return (
    <Tooltip title={tooltipTitle} arrow>
      <span>
        <StyledButton disabled={isButtonDisabled} onClick={onClick}>
          {buttonText}
        </StyledButton>
      </span>
    </Tooltip>
  );
}
